import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-6"
}
const _hoisted_2 = ["innerHTML"]

import { VueFormInputProps } from '@/composables/useFormInputData';
import { onMounted, ref, watch } from 'vue';
import RACQFormKit from '@/components/RACQFormKit/RACQFormKit.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import InformationBox from '@/components/InformationBox/InformationBox.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdatePostalAddressDisclaimer',
  props: {
    iqStore: {},
    bindings: {},
    stepActive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const model = ref<boolean>(false);
const showDisclaimer = ref<boolean>(false);

onMounted(async () => {
  showDisclaimer.value = await props.iqStore.checkUpdatePostalAddressRequired();
});

watch(
  () => props.stepActive,
  async (newValue: boolean) => {
    if (!newValue) return;
    showDisclaimer.value = await props.iqStore.checkUpdatePostalAddressRequired();
  }
);

return (_ctx: any,_cache: any) => {
  return (showDisclaimer.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(InformationBox, {
          type: _unref(InformationBoxTypes).WARNING
        }, {
          infoBoxContent: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _ctx.bindings.postContent
            }, null, 8, _hoisted_2),
            _createVNode(RACQFormKit, {
              modelValue: model.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
              bindings: _ctx.bindings,
              class: "py-2"
            }, null, 8, ["modelValue", "bindings"])
          ]),
          _: 1
        }, 8, ["type"])
      ]))
    : _createCommentVNode("", true)
}
}

})